import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import RaidGuideRoutes from "./submodules/raid-guides/routes"

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/component-test',
      name: 'component-test',
      component: () => import('./views/Tests/ComponentTest.vue')
    },
    {
      path: '/acquisition',
      name: 'test-acquisition',
      component: () => import('./views/Tests/Acquisition.vue')
    },
    {
      path: '/database/items',
      name: 'db-items',
      component: () => import('./views/Database/DatabaseItems.vue')
    },
    {
      path: '/database/recipes',
      name: 'db-recipes',
      component: () => import('./views/Database/DatabaseRecipes.vue')
    },
    {
      path: '/shinies/recipes',
      name: 'shinies-recipes',
      component: () => import('./views/Shinies/Index.vue')
    },
    {
      path: '/shinies/recipes/:buy(instant|order)',
      name: 'shinies-recipe-list',
      component: () => import('./views/Shinies/RecipeList.vue')
    },
    {
      path: '/shinies/recipes/crafting',
      name: 'shinies-recipe-calculator',
      component: () => import('./views/Shinies/CraftingCalculator.vue')
    },
    {
      path: '/economics/recipes/',
      name: 'economics-recipe-list',
      component: () => import('./views/Economics/RecipeList.vue')
    },
    {
      path: '/economics/usage/',
      name: 'economics-usage',
      component: () => import('./views/Economics/ItemUsage.vue')
    },
    {
      path: '/discord/',
      name: 'discord',
      component: () => import('./views/Discord/Discord.vue')
    },
    {
      path: '/guides/raids',
      name: 'raid-guides',
      component: () => import('./submodules/raid-guides/RaidGuides.vue'),
      children: RaidGuideRoutes.routes
    },
    {
      path: '/users/',
      name: 'users',
      component: () => import('./views/Users/UserList.vue')
    },
    {
      path: '/options/',
      name: 'options',
      component: () => import('./views/Options/Options.vue')
    },
    {
      path: '/tools/',
      name: 'tools',
      component: () => import('./views/Tools/Index.vue'),
      children: [
        {
          path: '',
          name: 'tools-summary',
          component: () => import('./views/Tools/Summary.vue'),
        },
        {
          path: 'manager',
          name: 'tools-manager',
          component: () => import('./views/Tools/Manager.vue'),
        },
        {
          path: 'inspector',
          name: 'tools-inspector',
          component: () => import('./views/Tools/Inspector.vue'),
        },
        {
          path: 'arcdps-clears',
          name: 'tools-arcdps-clears',
          component: () => import('./views/Tools/ArcdpsClears.vue'),
        },
        {
          path: 'library',
          name: 'tools-library',
          component: () => import('./views/Tools/Library.vue'),
        },
      ]
    },
    {
      path: '/calculators/',
      name: 'calculators',
      component: () => import('./views/Calculators/Index.vue'),
      children: [
        {
          path: '',
          name: 'calculator-about',
          component: () => import('./views/Calculators/About.vue')
        },
        {
          path: 'killproofs',
          name: 'calculator-killproofs',
          component: () => import('./views/Calculators/Killproofs.vue')
        },
        {
          path: 'ascended-food',
          name: 'calculator-ascended-food',
          component: () => import('./views/Calculators/AscendedFood.vue')
        },
        {
          path: 'assassins',
          name: 'calculator-gear-precision',
          component: () => import('./views/Calculators/GearPrecision.vue')
        },
      ]
    },
  ]
})
